import { render, staticRenderFns } from "./material-model-subtitles.vue?vue&type=template&id=7b081ed3&scoped=true"
import script from "./material-model-subtitles.vue?vue&type=script&setup=true&lang=js"
export * from "./material-model-subtitles.vue?vue&type=script&setup=true&lang=js"
import style0 from "./material-model-subtitles.vue?vue&type=style&index=0&id=7b081ed3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b081ed3",
  null
  
)

export default component.exports